import router from '@/router'
import config from '@/config/app-cfg'

export function login (id) {
  // set user id for further transactions
  config.SV_USER_ID = id
  localStorage.setItem('SV_USER_ID', id)
}

export function logout () {
  localStorage.removeItem('SV_USER_ID')
  router.go('/')
}

export function isLoggedIn () {
  config.SV_USER_ID = Number(localStorage.getItem('SV_USER_ID'))
  return localStorage.getItem('SV_USER_ID')
}
